import { adminSession } from '@/lib/api';

// Initials from the email's local-part: split on . _ - and take the first
// char of the first two segments (kmwinuka@… → KM after fallback below,
// first.last@… → FL). Falls back to the first two letters of the local-part
// when there's only one segment.
function initialsFromEmail(email: string): string {
  const local = email.split('@')[0] ?? '';
  const segments = local.split(/[._-]+/).filter(Boolean);
  const chars =
    segments.length >= 2
      ? segments[0][0] + segments[1][0]
      : local.slice(0, 2);
  return chars.toUpperCase() || '?';
}

export function SidebarIdentity({ onSignOut }: { onSignOut: () => void }) {
  const me = adminSession.getMe();
  if (!me) return null;

  return (
    <div style={cardStyle}>
      <div style={rowStyle}>
        <div style={avatarStyle} aria-hidden>
          {initialsFromEmail(me.email)}
        </div>
        <div style={metaStyle}>
          <div style={emailStyle} title={me.email}>
            {me.email}
          </div>
          <span style={roleStyle}>{me.role}</span>
        </div>
      </div>
      <button onClick={onSignOut} style={signOutStyle}>
        Sign out
      </button>
    </div>
  );
}

// ───── styles ─────────────────────────────────────────────────────────────

const cardStyle: React.CSSProperties = {
  background: 'var(--surface-2)',
  border: '1px solid var(--line)',
  borderRadius: 'var(--radius-md)',
  padding: 12,
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
};

const rowStyle: React.CSSProperties = {
  display: 'flex',
  gap: 10,
  alignItems: 'center',
};

const avatarStyle: React.CSSProperties = {
  width: 34,
  height: 34,
  flexShrink: 0,
  borderRadius: '50%',
  background: 'var(--coral-soft)',
  color: 'var(--coral-ink)',
  fontFamily: 'var(--font-mono)',
  fontSize: 13,
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const metaStyle: React.CSSProperties = {
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
};

const emailStyle: React.CSSProperties = {
  color: 'var(--ink-2)',
  fontSize: 13,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const roleStyle: React.CSSProperties = {
  alignSelf: 'flex-start',
  background: 'var(--chip)',
  color: 'var(--ink-3)',
  fontFamily: 'var(--font-mono)',
  fontSize: 10,
  letterSpacing: 1,
  textTransform: 'uppercase',
  borderRadius: 'var(--radius-sm)',
  padding: '2px 6px',
};

const signOutStyle: React.CSSProperties = {
  width: '100%',
  border: '1px solid var(--line-strong)',
  borderRadius: 'var(--radius-sm)',
  background: 'transparent',
  color: 'var(--coral)',
  fontFamily: 'var(--font-ui)',
  fontSize: 12,
  fontWeight: 500,
  padding: '6px 10px',
  cursor: 'pointer',
};
